export const DESCRIPTIONS = {
  TRADE_DOCUMENTS_DOWNLOAD: 'Click on any of the documents below to download and view:',
  TRADE_DOCUMENTS_APPROVE: 'Please download and review the terms and conditions:',
  DELETE_DRAFT_TRADE_CONFIRM:
    'Please confirm that you want to delete this draft trade.  All changes will be lost once deleted.',
  CONFIRM_TRADE_COMMIT:
    'By ticking this box and committing to this trade, you confirm that you have the necessary mandate and authorisation to enter into this transaction.'
}
